import { useSensorTransport } from '../transports/SensorTransportProvider';
import { TimelineFilters } from '../types/sensors';

export function useBoxTimeline(box_id: number | null, filters: TimelineFilters) {
  return useSensorTransport().useBoxTimeline(box_id, filters);
}
